import styled from "styled-components";
import tw from "twin.macro";

export const Title = styled.h1`
  /* font-size: 40px; */
  color: #000000;
  justify-content: center;
  ${tw`font-bold lg:text-[40px] md:text-[30px] text-[24px] w-[80%] md:w-[65%] xl:w-[45%] text-center lg:text-left`}
`;

export const SubTitle = styled.h3`
  /* font-size: 16px; */
  color: #1e1e1e;
  /* justify-content: center; */

  ${tw`mt-5 text-center lg:text-[16px] text-[14px] md:w-[75%] lg:w-[65%] xl:w-[40%] text-center px-10 md:px-0`}
`;

export const SubTitles = styled.h3`
  font-size: 16px;
  ${tw`font-semibold font-clash text-primaryColor`}
`;

export const Wrapper = styled.section`
  /* padding: 2em; */
  justify-content: center;
  /* width: screen; */
  ${tw`flex flex-col items-center justify-center`}
`;
export const MainWrapper = styled.section`
  /* width: screen; */
  background: var(
    --purpleishgrey-8,
    linear-gradient(to left, rgba(237, 243, 248, 1), rgba(237, 243, 248, 1)),
    linear-gradient(to left, rgba(237, 243, 248, 1), rgba(237, 243, 248, 1))
  );
  ${tw`justify-center w-full py-10 overflow-hidden font-clash lg:py-20`}
`;

export const Container = styled.div`
  width: max-content;
  height: max-content;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
  background-color: rgba(21, 97, 166, 0.2);
  ${tw`font-semibold font-clash text-primaryColor`}
`;
export const ImageWrapper = styled.img`
  /* width: 100%; */
  /* height: auto; */
  border-radius: 20px;
  /* justify-content: center; */
`;

export const ApiDetails = styled.div`
  ${tw`flex md:flex-row gap-10  xl:gap-[80px]`}
`;

export const ApiDocsContainer = styled.div`
  ${tw`flex flex-col items-center justify-center w-full gap-6 font-clash py-14`}
`;

export const ApiDocsImages = styled.div`
  ${tw`h-full w-full rounded-xl lg:px-44 lg:pb-20 px-[24px] pb-7 overflow-hidden flex items-center justify-center`}
`;

export const ApiDocImage = styled.img`
  ${tw`w-full xl:w-[60%] md:h-[350px] rounded-[15px]`}
`;
